import { render, staticRenderFns } from "./EditMapModal.vue?vue&type=template&id=10c3398a&scoped=true&"
import script from "./EditMapModal.vue?vue&type=script&lang=ts&"
export * from "./EditMapModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3398a",
  null
  
)

export default component.exports